export default {
  name: 'Days',
  props: {
    days: {
      type: Object
    }
  },
  data () {
    return {
      daysData: this.days
    }
  },
  computed: {
  },
  methods: {
    change: function (key) {
      if (this.daysData[key]) {
        this.daysData[key] = false;
      } else {
        this.daysData[key] = true;
      }
      this.$emit('updateDays', this.daysData);
    }
  }
}
